import { parse } from 'bcp-47'
import FrFlag from 'assets/svg/fr_flag.svg?react'
import UsFlag from 'assets/svg/us_flag.svg?react'
import RuFlag from 'assets/svg/ru_flag.svg?react'
import { format, isDate, isValid } from 'date-fns'
import { fr } from 'date-fns/locale'

export const fr_FR = 'fr-FR'
export const en_US = 'en-US'
export const ru_RU = 'ru-RU'

export const LANGUAGES = {
  [fr_FR]: fr_FR,
  [en_US]: en_US,
}

export const EXTERNAL_LANGUAGES = {
  [ru_RU]: ru_RU,
}

export function matchTag(tag = navigator.language) {
  // exact match
  if (Object.values(LANGUAGES).includes(tag)) return tag

  // similar match
  const { language } = parse(tag)
  for (const t in LANGUAGES) {
    const val = LANGUAGES[t]
    const { language: lang } = parse(val)
    if (language === lang) return val
  }

  // check in user preferences languages list
  for (const l of navigator.languages) {
    const { language } = parse(l)
    for (const t in LANGUAGES) {
      const val = LANGUAGES[t]
      const { language: lang } = parse(val)
      if (language === lang) return val
    }
  }

  // default value en-US
  return en_US
}

//https://stackoverflow.com/questions/2388115/get-locale-short-date-format-using-javascript
export function getLocaleDateString(locale, type = 'standard') {
  const formatsStandard = {
    [en_US]: 'mm/dd/yyyy',
    [fr_FR]: 'dd/mm/yyyy',
  }
  const formatsMedium = {
    [en_US]: 'mmm dd yyyy',
    [fr_FR]: 'dd mmm yyyy',
  }

  const formatsMediumComma = {
    [en_US]: 'mmm dd, yyyy',
    [fr_FR]: 'dd mmm, yyyy',
  }
  switch (type) {
    case 'medium':
      return formatsMedium[locale] || 'mmm dd yyyy'
    case 'medium-comma':
      return formatsMediumComma[locale] || 'mmm dd, yyyy'
    case 'standard':
    default:
      return formatsStandard[locale] || 'mm/dd/yyyy'
  }
}

function getFormatOptions({ language }) {
  const options = {}
  switch (language) {
    case fr_FR:
      options.locale = fr
      break
    default:
      // default us
      break
  }
  return options
}

export function formatDate({ date: dateUnix, language, type }) {
  const date = new Date(dateUnix)
  const dateFormat = getLocaleDateString(language, type).replaceAll('m', 'M')
  return isDate(date) && isValid(date) ? format(date, dateFormat, getFormatOptions({ language })) : date
}

export const LANGUAGES_FLAGS = {
  [fr_FR]: FrFlag,
  [en_US]: UsFlag,
  [ru_RU]: RuFlag,
}
